export function primeRate(value) {
  if (value == null || String(value).trim() === '') return null;
  const number = Number(String(value).replace(',', '.'));
  if (!Number.isFinite(number) || number === 0) return null;
  return number;
}

function labelOf(prime) {
  return String(prime?.TxtPrime || prime?.Designation || prime?.label || '').trim();
}

// Catalogue réel : référentiel agence, primes du client, puis celles du contrat (avec taux).
export function mergePrimeCatalog(globalPrimes = [], clientPrimes = [], contractPrimes = []) {
  const map = new Map();
  const put = (prime, withRate) => {
    if (!prime || typeof prime !== 'object') return;
    const label = labelOf(prime);
    if (!label) return;
    const idPrime = prime.IdPrime != null && String(prime.IdPrime).trim() !== '' ? String(prime.IdPrime) : '';
    const key = idPrime || label.toLowerCase();
    const current = map.get(key) || {
      value: key,
      label,
      idPrime,
      montant: null,
      montantNonAssujetti: null,
      tauxFacture: null,
    };
    if (withRate) {
      const taxable = primeRate(prime.TauxPayeImposable);
      const untaxed = primeRate(prime.TauxPayeNonImposable);
      const billed = primeRate(prime.TauxFacture);
      if (taxable != null) current.montant = taxable;
      if (untaxed != null) current.montantNonAssujetti = untaxed;
      if (billed != null) current.tauxFacture = billed;
      if (prime.TxtPrime) current.label = String(prime.TxtPrime).trim();
    }
    if (idPrime) current.idPrime = idPrime;
    map.set(key, current);
  };
  (Array.isArray(globalPrimes) ? globalPrimes : []).forEach(prime => put(prime, true));
  (Array.isArray(contractPrimes) ? contractPrimes : []).forEach(prime => put(prime, true));
  (Array.isArray(clientPrimes) ? clientPrimes : []).forEach(prime => put(prime, true));
  return [...map.values()];
}

export function applyPrimeRates(rows, catalog) {
  return (rows || []).map(row => {
    if (primeRate(row.montant) != null) return row;
    const match = (catalog || []).find(item =>
      (row.idPrime && item.idPrime && String(row.idPrime) === String(item.idPrime))
      || (item.label && row.type && item.label.toLowerCase() === String(row.type).toLowerCase())
    );
    if (!match) return row;
    const montant = row.nonAssujettie ? match.montantNonAssujetti : match.montant;
    if (montant == null) return row;
    return { ...row, montant, tauxFacture: row.tauxFacture ?? match.tauxFacture, idPrime: row.idPrime || match.idPrime };
  });
}

export function hourOptionsFromContract(contract) {
  const rows = Array.isArray(contract?.TabHeures) ? contract.TabHeures : [];
  const seen = new Set();
  return rows.flatMap(row => {
    const label = String(row?.TxtHeure || row?.Designation || row?.Libelle || '').trim();
    const key = label.toLowerCase();
    if (!label || seen.has(key)) return [];
    seen.add(key);
    return [{ value: key, label, taux: primeRate(row.TauxPaye ?? row.Taux) }];
  });
}
